import { fields } from '@/modules/proposalRequest/components/ProposalCreateForm/ProposalVerifyData/components/PartnerProposal/components/GoodsCreateForm/constants/goods.form';
import { createFieldsHook } from '@/utils/createFieldsHook';

export const DIALOG_PARTNER_GOODS_NAMESPACE = 'dialog_partner_goods_namespace';

export const useFields = createFieldsHook('proposalRequest', fields);
